import { useQuery } from '@tanstack/react-query';
import apiClient from './api-client';
const SCOPE = 'flinksInstitutions';
const keysFactory = {
    search: (keyword, language, financingProgram) => [{ scope: SCOPE, keyword, language, financingProgram }],
};
const searchInstitutions = async ({ queryKey: [{ keyword, language, financingProgram }], }) => {
    const response = await apiClient.get(`${financingProgram}/Flinks/SearchInstitutions`, {
        params: { keyword, language },
    });
    return response.data;
};
/**
 * Searches Flinks' institution catalog by keyword, through our own backend.
 *
 * The call is relayed by `FlinksInstitutionController` rather than issued straight to Flinks:
 * Flinks only returns CORS headers to its own iframe origin, so the browser cannot reach that
 * endpoint from our origin. The country filter and the Flinks customer-instance id both live
 * server-side.
 *
 * Stays idle until `keyword` is non-empty so the default, unsearched Select-Bank view never
 * calls the backend. Results are cached per keyword by the app's global `staleTime: Infinity`,
 * so backspacing through a search costs nothing.
 */
export function useSearchInstitutions(keyword, language, financingProgram) {
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.search(keyword, language, financingProgram),
        queryFn: searchInstitutions,
        enabled: Boolean(keyword),
    });
    return [data, isFetching];
}
